// extracted by mini-css-extract-plugin
export default {"button":"sj-z","reviewSort":"tj-z"};